<template>
    <div class="users">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>客户处设备</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top: 1rem; padding: 1.5rem 1rem 0 1rem; background-color: white">
            <el-form :inline="true" :model="query">
                <el-form-item label="设备名称:">
                    <el-input v-model="query.name" placeholder="设备名称"></el-input>
                </el-form-item>
                <el-form-item label="所属企业" prop="epId" >
                    <el-select v-model="query.epId" filterable placeholder="请选择">
                        <el-option
                                v-for="item in enterprises"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备型号" prop="standardId" >
                    <el-select v-model="query.typeId" filterable placeholder="请选择">
                        <el-option
                                v-for="item in standards"
                                :key="item.id"
                                :label="item.name + '-' + item.model"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="序号范围" prop="minSerialNo" >
                    <el-input v-model="query.minSerialNo" placeholder="最小序号" style="width: 140px"></el-input>
                </el-form-item>
                <el-form-item label="">
                    —
                </el-form-item>
                <el-form-item label="" prop="maxSerialNo" >
                    <el-input v-model="query.maxSerialNo" placeholder="最大序号" style="width: 140px"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onQuery">查询</el-button>
                    <el-button type="default" @click="query = {}">重置</el-button>
                    <el-button type="default" @click="exportQrCode">导出设备二维码</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="margin-top: 1rem; padding: 1rem; background-color: white">
            <el-button type="primary" style="margin-bottom: 1rem" @click="$router.push('/device/create')" size="small">添加客户处设备</el-button>
            <el-table
                    :data="devices"
                    border
                    stripe
                    v-loading="loading"
                    style="width: 100%">
                <el-table-column
                        prop="qrcode"
                        label="设备二维码"
                        width="120px"
                >
                    <template slot-scope="scope">
                        <a :href="scope.row.qrcode" target="_blank"><img :src="scope.row.qrcode" width="100px" ></a>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="serialNo"
                        sortable
                        label="产品序列号">
                </el-table-column>
                <el-table-column
                        prop="name"
                        sortable
                        :sort-method="(a, b) => a.name ? a.name.localeCompare(b.name, 'zh') : -1"
                        label="设备名称">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="deviceModel"
                        label="设备型号">
                </el-table-column>
                <el-table-column
                        sortable
                        :sort-method="(a, b) => a.epName ? a.epName.localeCompare(b.epName, 'zh') : -1"
                        prop="epName"
                        label="所属企业">
                </el-table-column>

                <el-table-column
                        prop="shareState"
                        sortable
                        label="用户类型">
                    <template slot-scope="scope">
                        {{scope.row.shareState == 0 ? '企业用户' : '个人用户'}}
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="anymousState"
                        label="匿名操作">
                    <template slot-scope="scope">
                        {{scope.row.shareState == 1 ? "-" : scope.row.anymousState == 1 ? '开启' : '关闭'}}
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="creator"
                        label="创建人"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="createTime"
                        label="创建时间"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="updator"
                        label="更新人"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="updateTime"
                        label="更新时间"
                >
                </el-table-column>
                <el-table-column label="操作" v-if="auth.accountType != 1">
                    <template slot-scope="scope">
                        <el-button @click="$router.push('/device/edit?id=' + scope.row.id)" type="text" size="small" >编辑</el-button>
<!--                        <el-button @click="$router.push('/user/address?id=' + scope.row.id)" type="text" size="small">配送地址</el-button>-->
                        <el-button @click="deleteDevice(scope.row.id)" type="text" size="small" >删除</el-button>
                    </template>
                </el-table-column>

            </el-table>
            <div style="text-align: center">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pagination.page"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import deviceApi from "../../api/device";
    import {mapState} from "vuex";
    import enterpriseApi from "../../api/enterprise";
    import deviceTypeApi from "../../api/deviceType";

    export default {
        data: function () {
            return {
                devices: [],
                loading: false,
                total: 0,
                pagination: {
                    page: sessionStorage.getItem("page") || 1,
                    pageSize: 10
                },
                query: {

                },
                enterprises: [],
                standards: [],
            }
        },
        computed: {
            ...mapState("auth", {
                auth: state => state
            }),
        },
        mounted() {
            this.loadEnterprises();
            this.loadTypes();
            this.loadUsers();
        },
        methods: {
            deleteDevice: function(id) {
                this.$confirm('确定删除该设备？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    deviceApi.deleteById(id).then(result => {
                        this.loading = false;
                        this.loadUsers();
                    })
                });
            },
            loadUsers: function () {
                this.loading = true;
                deviceApi.getAll({...this.query, ...this.pagination}).then(result => {
                    this.loading = false;
                    this.devices = result.data;
                    this.total = result.total;
                })
            },
            onQuery: function () {
                this.pagination = {
                    page: 1,
                    pageSize: 10
                }
                this.loadUsers();
            },
            handleSizeChange: function (size) {
                this.pagination = {
                    page: 1,
                    pageSize: size
                }
                this.loadUsers();
            },
            handleCurrentChange: function (page) {
                sessionStorage.setItem("page", page);
                this.pagination = {
                    ...this.pagination,
                    page: page,
                }
                this.loadUsers();
            },
            loadEnterprises: function () {
                enterpriseApi.getAll2().then(res => {
                    this.enterprises = res;

                })
            },
            onEpChange: function () {
                console.log(this.query.epId)
                const epId = this.query.epId;
                if(epId) {
                    this.form = {
                        ...this.form,
                        standardId: null
                    }

                }
            },
            loadTypes: function () {
                deviceTypeApi.getAll().then(res => this.standards = res);
            },
            exportQrCode: function () {
                let queryStr = "?t=1";
                if(this.query.name) {
                    queryStr += "&name=" + this.query.name;
                }
                if(this.query.epId) {
                    queryStr += "&epId=" + this.query.epId;
                }
                if(this.query.typeId) {
                    queryStr += "&typeId=" + this.query.typeId;
                }
                if(this.query.minSerialNo) {
                    queryStr += "&minSerialNo=" + this.query.minSerialNo;
                }
                if(this.query.maxSerialNo) {
                    queryStr += "&maxSerialNo=" + this.query.maxSerialNo;
                }
                window.open("/admin/device/exportQrcodes" + queryStr);
            }
        }
    }
</script>
